import { Link } from 'react-router-dom';
import { ModuleLanding, ModuleOffers, Faq, SectionHead } from '../../shared/components/Common';
import Icon from '../../shared/components/Icons';
import { addDaysIso, img } from '../../shared/data/common';
import { popularTransfers, rideTypes } from './data';
import { journeyLabel, parseTransferQuery, transferQueryString } from './searchModel';

const perks = [
  ['user', 'Meet & greet', 'Airport pickups include a driver waiting with your name board'],
  ['clock', 'Free waiting time', 'Up to 60–90 minutes free at airports, shown on every cab'],
  ['wallet', 'All-inclusive prices', 'One price for the whole cab — taxes included'],
  ['pin', 'Live driver tracking', 'Track your driver from My Trips once assigned'],
];

const faqs = [
  ['Is the price per person or per cab?', 'Per cab. One price covers everyone travelling, up to the seats shown on the cab.'],
  ['How early do I need to book?', 'Pickup must be at least 2 hours from when you book. Book earlier for the best choice of cabs.'],
  ['What happens if my flight is late?', 'Add your flight number at checkout — the driver tracks your flight. Airport pickups include free waiting time.'],
  ['When will I get driver details?', 'Usually within 12 hours of pickup for trips in India (6 hours abroad). You can track your driver from My Trips.'],
  ['Can I cancel?', 'Yes, from My Trips. Most cabs are free to cancel up to 24 hours before pickup; each cab shows its own cancellation rules. The convenience fee is not refunded.'],
  ['Are tolls and extra stops included?', 'Fares are all-inclusive for the route you booked. Extra stops or changes once the trip starts are paid to the driver.'],
];

/** Results link for a popular route, picked up on a date a week ahead. */
const routeLink = (route) => `/transfers/results?${transferQueryString(parseTransferQuery({
  journey: route.journey, pickup: route.pickup, drop: route.drop, date: addDaysIso(7), time: '10:00', passengers: 2,
}))}`;

export default function TransferSearch() {
  return (
    <ModuleLanding tab="transfers" title="Airport transfers & cabs" subtitle="Airport transfers, outstation and local cabs · All-inclusive prices · Meet & greet at airports" image={img('1449965408869-eaa3f722e40d', 1800)}>
      <section className="section container">
        <div className="perk-row">
          {perks.map(([ic, t, d]) => (
            <div key={t} className="perk"><span className="perk-icon"><Icon name={ic} size={22} /></span><div><b>{t}</b><span className="muted small">{d}</span></div></div>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Popular routes" />
        <div className="route-grid three">
          {popularTransfers.map((route) => (
            <Link key={`${route.pickup}-${route.drop}`} to={routeLink(route)} className="route-card">
              <span className="route-icon"><Icon name={route.journey === 'airport' ? 'flights' : 'transfers'} size={20} /></span>
              <div className="route-info"><b>{route.pickup}</b><span className="muted small">to {route.drop}</span></div>
              <div className="route-price"><span className="muted small">{journeyLabel(route.journey)}</span><b>View cabs</b></div>
            </Link>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Choose your ride" />
        <div className="vehicle-strip">
          {rideTypes.map((v) => (
            <div key={v.name} className="vehicle-chip">
              <span className="transfer-icon sm"><Icon name="transfers" size={26} strokeWidth={1.5} /></span>
              <b>{v.name}</b><span className="muted small">{v.example} · up to {v.seats} seats</span>
            </div>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Transfer offers" />
        <ModuleOffers module="transfers" />
      </section>

      <section className="section container">
        <SectionHead title="Frequently asked questions" />
        <Faq items={faqs} />
      </section>
    </ModuleLanding>
  );
}
